export const SpacingMicro = "4px";
export const SpacingXs = "8px";
export const SpacingS = "12px";
export const SpacingBase = "16px";
export const SpacingM = "20px";
export const SpacingL = "24px";
export const SpacingXl = "32px";
export const SpacingXxl = "40px";
